import clamp from "../clamp";
export default function calculateCarouselIndex(offsetX, pageWidth, itemCount) {
    if (pageWidth <= 0 || itemCount <= 0) {
        return 0;
    }
    const targetIndex = Math.round(offsetX / pageWidth);
    return clamp(targetIndex, 0, itemCount - 1);
}
//# sourceMappingURL=calculateCarouselIndex.js.map